import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LocationDto, LocationHistoryDto, SendCommandDto } from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;
@Component({
  selector: 'app-locate',
  templateUrl: './locate.component.html',
})
export class LocateComponent implements OnInit {
  clickShowTrace: number = 0;
  clickLockDevice: number = 0;
  traceOperation: string = 'All';
  daysDropDown: any = [];
  mapsAPILoader: any;
  event: boolean;
  selectedLocation: Array<LocationDto> = [];
  constructor(
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private _service: ApiService,
    private _toaster: ToastrService,
    private location: Location,
    private translateService: TranslateService
  ) {

  }
  LocationDto: LocationHistoryDto = new LocationHistoryDto();

  isLoading: boolean = false;
  isLock: boolean = false;
  // google maps zoom level
  zoom: number = 8;
  pageSize: number = 10;
  pageNumber: number = 0;
  currentPage: number = 1;
  totalItems: number = 0;
  totalItemsTemp: number = 0;
  isFilterApplied: any;
  showPage: boolean = true;
  errorMessage: string = '';
  deviceId: string = '';
  allChecked: boolean = false;
  getUserDeviceData: any;
  getMyDeviceData: any;
  deviceIdList = new Set();
  individualChecked: boolean = false;
  getLocationHistory: any[] = [];
  locationInfoDto: any;
  isShowFilter: any;
  whitefilter: boolean = false;
  grayfilter: boolean = false;
  activeFilter: string = 'whiteFilter';
  inActivefilter: string = 'grayFilter';
  totalFIlterCountVal: boolean = false;
  filterClass: string = '';
  data: any = {};
  address: any;
  locationFilterType: string = 'LAST_7_DAYS';
  pagelengthData: number = 10;
  pageData?: number = 0;

  mobileDevice: any = [];
  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;
  myLatLng = {
    lat: 0,
    lng: 0,
    locname: '',
  };
  mapOptions: google.maps.MapOptions = {};

  markerOptions: google.maps.MarkerOptions = {};
  sendCommanddto: SendCommandDto = new SendCommandDto();
  spots: { id: 0; lat: number; lng: number; locname: string; name: string }[] = [];

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getLocation('All');
    }, 10)
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
  }

  restorePublishForm: FormGroup = new FormGroup({
    mobileDeviceName: new FormControl(''),
  });

  daysDropDownForm: FormGroup = new FormGroup({
    locationFilterType: new FormControl(''),
  });

  ngOnInit(): void {
    let daysDropDown = [];
    this.translateService.get(['DAYS_DROP_DOWN']).subscribe((values) => {
      daysDropDown = Object.keys(values).map((key) => values[key]);
      this.daysDropDown = daysDropDown[0];
    });
    this.clickShowTrace = 0;
    this.clickLockDevice = 0;
    this.deviceId = this.activatedRoute.snapshot.params['id'];
    this.getDevicesInUser();
    this.getTraceSetting();
    scrollTo(0, 0);
  }
  getDevicesInUser() {
    this.isLoading = true;
    try {
      this._service
        .getService(this._service.API_URL.getDevicesInUser)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.mobileDevice = response.data;
            if (this.deviceId) {
              this.mobileDevice.forEach((element: any) => {
                if (this.deviceId == element.id) {
                  this.restorePublishForm.controls['mobileDeviceName'].setValue(
                    element.id
                  );
                }
              });
            } else {
              this.deviceId = response.data[0].id;
              let deviceId = response.data[0].id;
              this.restorePublishForm.controls['mobileDeviceName'].setValue(
                deviceId
              );
            }
          } else {
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.isLoading = false;
    }
  }

  onMobileDeviceSelect(event: any) {
    this.trace = false;
    this.deviceId = event.target.value;
    this.getCommands();
    this.getLocation('All');
    this.getTraceSetting()
  }
  goBack() {
    this.location.back();
  }

  openLockModal() {
    $('#LockPopup').modal('show');
    this.isLock = false;
  }

  isLockClicked() {
    this.isLock = true;
  }

  latitude: number = 0;
  logitude: number = 0;
  locationName: string = "";
  markers: marker[] = [
    {
      lat: this.latitude,
      lng: this.logitude,
      locname: this.locationName,
      label: 'A',
      draggable: true,
    },
  ];
  openInfoWindow(marker: MapMarker, infoWindow: MapInfoWindow) {
    infoWindow.open(marker);
  }

  // Fetching the location table data here
  getCommands() {
    try {
      this.isLoading = true;
      this._service
        .getService(
          this._service.API_URL.getCommands +
          this.deviceId +
          '/UPDATE_ALL_DETAILS'
        )
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
          }
          this.isLoading = false;
        });
    } catch (error) {
      this.isLoading = false;
    }
  }
  getCurrentLocation() {
    let geocoder = new google.maps.Geocoder();
    let latlng = { lat: this.lat, lng: this.long };
    geocoder.geocode({ location: latlng }, (results: any) => {
      if (results && results[0]) {
        this.addressses = results[0].formatted_address;
        console.log(this.addressses, 'this.currentLocation');
      } else {
        console.log('No results found');
      }
    });
  }
  // Fetching the location data here
  lat: any;
  long: any;
  locationName1: any;
  addressses: string;
  getLocation(traceOperation: any) {
    this.isLoading = true;
    this.traceOperation = traceOperation;
    this.LocationDto = new LocationHistoryDto();
    this.LocationDto.pageNumber = this.pageData = 0;
    this.LocationDto.pageSize = this.pagelengthData;
    this.LocationDto.deviceId = this.deviceId;
    this.LocationDto.locationFilterType = this.locationFilterType;
    if (this.traceOperation == 'All') {
      this.clickLockDevice = 0;
      this.clickShowTrace = 0;
      this.LocationDto.traceOperation = -1;
    } else if (this.traceOperation == 'BLOCK') {
      this.clickLockDevice = 1;
      this.clickShowTrace = 0;
      this.LocationDto.traceOperation = 0;
    } else if (this.traceOperation == 'TRACE') {
      this.clickLockDevice = 0;
      this.clickShowTrace = 1;
      this.LocationDto.traceOperation = 3;
    }
    this._service
      .getService(
        this._service.API_URL.getLocation +
        this.LocationDto.deviceId +
        '?pageNumber=' +
        this.LocationDto.pageNumber +
        '&pageSize=' +
        this.LocationDto.pageSize +
        '&locationFilterType=' +
        this.locationFilterType +
        '&traceOperation=' +
        this.LocationDto.traceOperation
      )
      .subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.getLocationHistory = response?.data;
          this.deviceIdList.add(this.getLocationHistory[0].id);
          this.getLocationHistory[0].isChecked = true;
          this.totalItemsTemp = response.page.totalElements;
          this.currentPage = response.page.currentPageNo;
          if (response.page.totalElements < 10) {
            this.showPage = false;
          } else {
            this.showPage = true;
          }
          this.lat = Number(response.data[0]?.latitude);
          this.long = Number(response.data[0]?.longitude);
          this.locationName = String(response.data[0]?.locationName);
          this.getCurrentLocation();
          this.spots.push({ id: 0, lat: this.lat, lng: this.long, name: '', locname: this.locationName });
          this.myLatLng = {
            lat: this.lat,
            lng: this.long,
            locname: this.locationName,
          };
          var latlong = new google.maps.LatLng(this.myLatLng);
          this.mapOptions = {
            center: latlong,
            minZoom: 8,
            maxZoom: 100,
            panControl: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoomControl: true,
            scrollwheel: true,
            disableDoubleClickZoom: true,
          };
          var map = new google.maps.Map($('#map-canvas')[0], this.mapOptions);
          var rangeCircle = new google.maps.Circle({
            center: latlong,
            radius: 700,
            strokeColor: '#A0A0E6',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#A0A0E6',
            fillOpacity: 0.4,
          });
          rangeCircle.setMap(map);
        } else {
          this.isLoading = false;
          this._toaster.error('', response.status.message);
        }
        this.isLoading = false;
      });
  }

  showMap(data: any) {
    this.spots = [];
    this.selectedLocation = [];
    if (this.deviceIdList != null && this.deviceIdList.size > 0) {
      this.deviceIdList.forEach((id) => {
        this.selectedLocation.push(this.getLocationHistory.find(item => item.id === id));
      })
    }
    this.selectedLocation.forEach((location, index) => {
      const lat = Number(location.latitude);
      const lng = Number(location.longitude);
      const locationName = String(location.locationName);

      this.spots.push({
        id: 0,
        lat: lat,
        lng: lng,
        name: '',
        locname: locationName
      });
      if (index === 0) {
        this.myLatLng = {
          lat: lat,
          lng: lng,
          locname: locationName,
        };

        const latlong = new google.maps.LatLng(this.myLatLng);
        this.mapOptions = {
          center: latlong,
          minZoom: 8,
          maxZoom: 100,
          panControl: true,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          zoomControl: true,
          scrollwheel: true,
          disableDoubleClickZoom: true,
        };
      }
    });
  }


  deleteLocation() {
    if (this.getLocationHistory && this.getLocationHistory?.length != 0) {
      $('#deletePopup').modal('hide');
      this._service
        .deleteService(this._service.API_URL.deleteLocation + this.deviceId)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this._toaster.success('', response.status.message);
            this.getLocation(this.traceOperation);
          } else {
            this._toaster.error('', response.status.message);
          }
        });
    }
  }

  checkBeforeDeleting() {

    if (this.getLocationHistory && this.getLocationHistory?.length != 0) {

      $('#deletePopup').modal('show');
    }

  }

  //  Fetching the Device Id here and Passing the data to the TransferOwnership for Transfer Ownership
  onDeviceClick(event: any, data: any, type: string) {
    if (type == 'single') {
      if (event.target.checked && !this.allChecked) {
        this.deviceIdList.add(data.id);
        this.allChecked = this.getLocationHistory?.length == this.deviceIdList.size;
        this.getLocationHistory.find(item => item.id === data.id).isChecked = true;
        this.showMap(data);
      }
      else {
        this.allChecked = false
        this.deviceIdList.delete(data.id)
        this.individualChecked = this.deviceIdList.size > 0
        this.getLocationHistory.find(item => item.id === data.id).isChecked = false;
        this.showMap(data);
      }
    }
    else {
      this.deviceIdList = new Set();
      if (event.target.checked) {
        data.forEach((element: any) => {
          this.allChecked = true
          this.individualChecked = true
          this.getLocationHistory.forEach((item) => {
            item.isChecked = true;
            this.deviceIdList.add(element.id)
          });
          this.deviceIdList.add(element.id);
          this.showMap(data);
        })
      }
      else {
        data.forEach((element: any) => {
          this.individualChecked = false
          this.allChecked = false
          this.getLocationHistory.forEach((item) => {
            item.isChecked = false;
            this.deviceIdList.delete(element.id)
          });
          this.showMap(data);
        })
      }
    }
  }

  deleteLocationByLocationId(id: any) {
    this._service
      .deleteService(
        this._service.API_URL.deleteLocation +
        this.deviceId +
        '?locationId=' +
        id
      )
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this._toaster.success('', response.status.message);
          this.getLocation(this.traceOperation);
          this.deviceIdList.delete(id);
          this.showMap(id);
        } else {
          this._toaster.error('', response.status.message);
        }
      });
  }

  // Send Command
  sendCommand(type: any) {
    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = this.deviceId;
      this.sendCommanddto.requestType = type;
      this._service
        .postService(this._service.API_URL.sendCommand, this.sendCommanddto)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this._toaster.success('', response.status.message);
            this.getLocation(this.traceOperation);
            this.isLock = true;
          } else {
            this.isLoading = false;
            // this.errorMessage = response.status.message;
            this._toaster.error('', response.status.message);
          }
        });
    } catch (error) {
      this.isLoading = false;
    }
  }

  // SELETING THE PAGE SIZE
  pageSizeList(page: any) {
    this.isLoading = true;
    this._service
      .getService(this._service.API_URL.getLocation + this.deviceId)
      .subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.getLocationHistory = response.data;
          this.totalItemsTemp = Math.ceil(
            (response.page.totalElements / page) * 10
          );
          this.currentPage = response.page.currentPageNo;
          if (response.page.totalElements < 10) {
            this.showPage = false;
          }
        } else {
          this.isLoading = false;
          this._toaster.error('', response.status.message);
        }
      });
  }

  page?: number;
  pageChanged(event: any) {
    if (event != 0) {
      this.page = event - 1;
    }
    this.LocationDto = new LocationHistoryDto();
    this.LocationDto.pageNumber = this.page;
    this.LocationDto.pageSize = this.pageSize;
    this.LocationDto.deviceId = this.deviceId;
    if (this.traceOperation == 'All') {
      this.LocationDto.traceOperation = -1;
    } else if (this.traceOperation == 'BLOCK') {
      this.LocationDto.traceOperation = 0;
    } else if (this.traceOperation == 'TRACE') {
      this.LocationDto.traceOperation = 3;
    }
    this._service
      .getService(
        this._service.API_URL.getLocation +
        this.deviceId +
        '?pageNumber=' +
        this.LocationDto.pageNumber +
        '&pageSize=' +
        this.LocationDto.pageSize +
        '&locationFilterType=' +
        this.locationFilterType +
        '&traceOperation=' +
        this.LocationDto.traceOperation
      )
      .subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.getLocationHistory = response.data;
          this.totalItemsTemp = response.page.totalElements;
          if (response.page.totalElements < 10) {
            this.showPage = false;
          } else {
            this.showPage = true;
          }
        } else {
          this.isLoading = false;
          this._toaster.error('', response.status.message);
        }
      });
    this.LocationDto = new LocationHistoryDto();
  }

  onDaysDropDownSelect(event: any) {
    if (event != 0) {
      this.pageData = event - 1;
    }
    this.deviceIdList = new Set();
    this.allChecked = false;
    this.locationFilterType = event.target.value;
    this.LocationDto = new LocationHistoryDto();
    this.LocationDto.pageNumber = this.pageData = 0;
    this.LocationDto.pageSize = this.pagelengthData;
    this.LocationDto.deviceId = this.deviceId;
    this.LocationDto.locationFilterType = this.locationFilterType;
    if (this.traceOperation == 'All') {
      this.LocationDto.traceOperation = -1;
    } else if (this.traceOperation == 'BLOCK') {
      this.LocationDto.traceOperation = 0;
    } else if (this.traceOperation == 'TRACE') {
      this.LocationDto.traceOperation = 3;
    }
    this._service
      .getService(
        this._service.API_URL.getLocation +
        this.LocationDto.deviceId +
        '?pageNumber=' +
        this.LocationDto.pageNumber +
        '&pageSize=' +
        this.LocationDto.pageSize +
        '&locationFilterType=' +
        this.locationFilterType +
        '&traceOperation=' +
        this.LocationDto.traceOperation
      )
      .subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.getLocationHistory = response.data;
          this.deviceIdList.add(this.getLocationHistory[0].id);
          this.getLocationHistory[0].isChecked = true;
          this.showMap(this.getLocationHistory[0].id);
          this.totalItemsTemp = response.page.totalElements;
          this.currentPage = response.page.currentPageNo;
          if (response.page.totalElements < 10) {
            this.showPage = false;
          } else {
            this.showPage = true;
          }
        } else {
          this.isLoading = false;
          this._toaster.error('', response.status.message);
        }
      });
  }

  // Trace Settings
  trace: boolean = false;
  checkValue(event: any) {
    this.trace = event.target.checked;
    this.traceDeviceSettings(event.target.checked);
  }

  traceDeviceSettings(event: any) {
    //this.event = this.trace;
    this.isLoading = true;
    let data = {
      deviceId: this.deviceId,
      traceDeviceOn: this.trace,
    };
    this._service
      .postService(this._service.API_URL.traceDeviceSettings, data)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toaster.success('', response.status.message);
          this.getTraceSetting();
        } else {
          this.trace = !event;
          this._toaster.error('', response.status.message);
        }
        this.isLoading = false;
      });
  }

  delete() { }

  getTraceSetting() {
    this.isLoading = true;
    this._service
      .getService(this._service.API_URL.getTraceSetting + this.deviceId)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.trace = response.data;
        } else {
          this.isLoading = false;
          this._toaster.error('', response.status.message);
        }
      });
  }

  checkLocateDevice() {
    $('#locatePopup').modal('show');
  }
}
// just an interface for type safety.
export interface marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
  locname: string;
}


